import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SsoService } from '@devinforius/i-sso';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
})
export class PublicComponent implements OnInit {
  private readonly ssoService: SsoService = inject(SsoService);
  private readonly router: Router = inject(Router);
  private readonly activeRoute: ActivatedRoute = inject(ActivatedRoute);

  public readonly subtitle: string = 'Bonjour,';
  public readonly description: string = `Pour des questions de sécurité, vous allez être redirigé vers notre plateforme d'authentification afin de vous connecter à l'application.<br>Si vous ne voulez pas attendre la redirection ou si celle-ci ne fonctionne pas, veuillez cliquer sur le bouton ci-dessous.`;

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((params: any) => {
      if (params.duplicateFile === 'true' || params.duplicateFile === true) {
        localStorage.setItem('iDelibe_duplicateFileFromiCourrier', 'true');
      }
      if (params && params.icourrier_id) {
        localStorage.setItem('iDelibe_icourrier_id_send', params.icourrier_id);
      }
    });

    if (this.ssoService.hasValidAccessToken()) {
      this.router.navigateByUrl('/private');
    }
  }

  login() {
    if (this.ssoService.hasValidAccessToken()) {
      this.ssoService.setConnection(true);
    } else {
      this.ssoService.login();
    }
  }
}
